import { toggleAttr } from './utils.js';

// открытие/закртие выпадающих списков
export function showDropDownList() {
  if (this) this.disabled = true;

  const parentElement = this.parentElement;
  const dropDownContent = parentElement.querySelector('[data-role=drop-down]');
  const isOpening = !parentElement.classList.contains('js_dke_active');

  parentElement.classList.toggle('js_dke_active');
  toggleDropDown(dropDownContent, () => {
    if (this) this.disabled = false;
  });
  updateAriaExpanded(parentElement);

  // Устанавливаем слушатель клика на документ для закрытия dropdown при клике снаружи
  if (isOpening) {
    setupDocumentClickListener(parentElement);
  } else {
    removeDocumentClickListener(parentElement);
  }
}

// Устанавливаем слушатель клика на документ для закрытия dropdown при клике снаружи
function setupDocumentClickListener(dropdownElement) {
  const closeHandler = (e) => {
    // Проверяем, что клик произошел вне dropdown элемента
    if (!dropdownElement.contains(e.target)) {
      closeDropDown(dropdownElement);
      document.removeEventListener('click', closeHandler);
    }
  };

  document.addEventListener('click', closeHandler);
  // Сохраняем обработчик на элементе для возможности его удаления
  dropdownElement._dropdownClickHandler = closeHandler;
}

function removeDocumentClickListener(dropdownElement) {
  if (dropdownElement._dropdownClickHandler) {
    document.removeEventListener('click', dropdownElement._dropdownClickHandler);
    dropdownElement._dropdownClickHandler = null;
  }
}

// Функция для закрытия dropdown
function closeDropDown(parentElement) {
  if (!parentElement) return;

  const dropDownContent = parentElement.querySelector('[data-role=drop-down]');

  parentElement.classList.remove('js_dke_active');
  
  if (dropDownContent && dropDownContent.style.height) {
    close(dropDownContent);
  }

  updateAriaExpanded(parentElement);
}

export function closeAllDropDown(btnsDropDown, excludedIndex) {
  btnsDropDown.forEach((element, index) => {
    if (index !== excludedIndex) {
      element.disabled = false;
      const parentElement = element.parentElement;
      parentElement.classList.remove('js_dke_active');
      const dropDownContent = parentElement.querySelector('[data-role=drop-down]');
    
      if (dropDownContent.style.height) {
        close(dropDownContent);
      }
    }
  });
}

// открытие/закрытие выпадающего списка
function toggleDropDown(element, updateDisabled) {
  if (element) {
    if (element.style.height === '') {
      open(element, updateDisabled);
    }
    else {
      close(element, updateDisabled);
    }
  }
}

// открытие выпадающего списка
function open(element, updateDisabled) {
  const endHeight = element.scrollHeight + 'px';
  element.style.height = '0px';
  requestAnimationFrame(() => {
    element.style.height = endHeight;
  });

  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    element.style.height = 'auto';
    updateDisabled?.();
  };

  element.addEventListener('transitionend', finish, { once: true });
  setTimeout(finish, 400); // fallback: если transitionend не сработал (CSS ещё не загружен)
}

// закрытие выпадающего списка
function close(element, updateDisabled) {
  const endHeight = window.getComputedStyle(element).height;
  element.style.height = endHeight;
  requestAnimationFrame(() => {
    element.style.height = '0px';
  });

  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    element.removeAttribute('style');
    updateDisabled?.();
  };

  element.addEventListener('transitionend', finish, { once: true });
  setTimeout(finish, 400); // fallback: если transitionend не сработал (CSS ещё не загружен)
}

// поиск элемента с атрибутом aria-expanded и изменение его значения
function updateAriaExpanded(parentElement) {
  if (parentElement.hasAttribute('aria-expanded')) {
    toggleAttr(parentElement, 'aria-expanded');
  } else {
    const elementAriaAttr = parentElement.querySelector('[aria-expanded]');
    if (elementAriaAttr) {
      toggleAttr(elementAriaAttr, 'aria-expanded');
    }
  }
}
